import { FC } from 'react';
import Head from 'next/head';
import { PageHeadType } from '@/types';

const PageHead: FC<PageHeadType> = ({
  title,
  contentDescription,
  contentKeywords,
  contentAuthor,
}) => {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={contentDescription}></meta>
        <meta name="keywords" content={contentKeywords}></meta>
        <meta name="author" content={contentAuthor}></meta>
        <link rel="icon" href="/favicon.ico"></link>
      </Head>
    </>
  );
};

export default PageHead;
